"use client";
import { usePathname } from "next/navigation";
import { NavigationItem } from "../../navigation/models";
import { NextLink } from "cy-fe";
import { cn } from "cy-fe/src/utils/cn";

export function DrawerSideNav({
  navigation,
  onClick: closeSidebar,
}: {
  navigation: NavigationItem[];
  onClick: () => void;
}) {
  const pathName = usePathname();
  return (
    <nav className="flex flex-1 flex-col pt-5">
      <ul className="flex flex-1 flex-col gap-y-7">
        <li>
          <ul className="-mx-2 space-y-1">
            {navigation.map((item) => (
              <li key={item.name}>
                <NextLink
                  className={cn(
                    item.current(pathName)
                      ? "font-semibold text-black"
                      : "font-normal text-slate-600 hover:font-semibold hover:text-black",
                    "group flex gap-x-3 rounded-md p-2 text-sm leading-6",
                  )}
                  href={item.action as string}
                  onClick={closeSidebar}
                >
                  <item.icon
                    aria-hidden="true"
                    className={cn(
                      item.current(pathName)
                        ? "text-black"
                        : "text-slate-600 group-hover:font-semibold group-hover:text-black",
                      "h-6 w-6 shrink-0",
                    )}
                  />
                  {item.name}
                </NextLink>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </nav>
  );
}
